import React from 'react';
import '../styles/videorow.css';

import VideoCard from './VideoCard';
import { Box, Grid } from '@material-ui/core';

const VideoRow = ({ title }) => {
  return (
    <div className="videorow">
      <div className="videorow__icon">
        <h2> {title}</h2>
      </div>
      <Box>
        <Grid container spacing={3}>
          <Grid item lg={3} md={4} sm={6}>
            <VideoCard
              videoImg="https://i.ytimg.com/vi/ggJMQHltiQc/maxresdefault.jpg"
              videoTitle="Title"
              description="Description"
              views="64"
              timestamp="12 days agp"
              videoDuration="02:18"
            />
          </Grid>
          <Grid item lg={3} md={4} sm={6}>
            <VideoCard
              videoImg="https://i.ytimg.com/vi/ggJMQHltiQc/maxresdefault.jpg"
              videoTitle="Title"
              description="Description"
              views="64"
              timestamp="12 days agp"
              videoDuration="02:18"
            />
          </Grid>{' '}
          <Grid item lg={3} md={4} sm={6}>
            <VideoCard
              videoImg="https://i.ytimg.com/vi/ggJMQHltiQc/maxresdefault.jpg"
              videoTitle="Title"
              description="Description"
              views="64"
              timestamp="12 days agp"
              videoDuration="02:18"
            />
          </Grid>{' '}
          <Grid item lg={3} md={4} sm={6}>
            <VideoCard
              videoImg="https://i.ytimg.com/vi/ggJMQHltiQc/maxresdefault.jpg"
              videoTitle="Title"
              description="Description"
              views="64"
              timestamp="12 days agp"
              videoDuration="02:18"
            />
          </Grid>{' '}
        </Grid>
      </Box>
    </div>
  );
};

export default VideoRow;
